import CanVisitMiddleware from '@/middleware/CanVisitMiddleware.js';

export default [
    {
        path: '/help',
        name: 'help-home',
        component: () => import('@/pages/help/HelpIndex.vue'),
        children: [
            {
                path: '/help/:articleId',
                name: 'help-show',
                component: () => import('@/components/help/HelpArticle.vue'),
                props: true,
                meta: {
                    title: 'Help',
                    middleware: [CanVisitMiddleware],
                    ability: { action: 'view', subject: 'help' },
                },
            },
        ],
    },
];
